import { EventNames, trackSegmentAndGAEvent } from '@zoopla/tracking';
import { HousePricesPage, HousePricesSearchType } from '../types';

// These are stored as a map rather than generated based on type and parent to
// make it eaiser to find them, and to understand the relationship between them.
// Notably, for consistency with existing data, the "area" search on the landing
// page does not take an "- area" suffix, whereas the others all take the suffix
// of their respective search type (using postcode instead of property).
type SearchTypeLabelMap = Record<HousePricesPage, string>;
const EVENT_LABEL_MAP: Record<HousePricesSearchType, SearchTypeLabelMap> = {
    area: {
        landing: 'house prices',
        results: 'house prices results - area'
    },
    property: {
        landing: 'house prices - postcode',
        results: 'house prices results - postcode'
    }
};

export const trackHousePricesSearch = (
    parent: HousePricesPage,
    type: HousePricesSearchType
) => {
    trackSegmentAndGAEvent(
        EventNames.SEARCH_CLICK,
        {
            eventAction: 'click',
            eventCategory: 'search results',
            eventLabel: EVENT_LABEL_MAP[type][parent]
        },
        '/house-prices/'
    );
};
